module.exports = __webpack_public_path__ + "static/media/referral.247a9634.svg";